const e=({typography:t})=>({styleOverrides:{root:{...t.h4}}});export{e as default};
